export const EARTH_DEMO_ROUNDS = Object.freeze([
  {
    id: 'earth_demo_1',
    imageSrc: '/Earth1.png',
    answer: Object.freeze({ lat: -14.0555, lng: -49.3673 }),
  },
  {
    id: 'earth_demo_2',
    imageSrc: '/Earth2.png',
    answer: Object.freeze({ lat: 3.7448, lng: 98.6712 }),
  },
  {
    id: 'earth_demo_3',
    imageSrc: '/Earth3.png',
    answer: Object.freeze({ lat: 33.4514, lng: -99.3350 }),
  },
]);

export const pickRandomEarthDemoRound = (lastRoundId = '') => {
  const normalizedLastRoundId = String(lastRoundId || '').trim();
  if (EARTH_DEMO_ROUNDS.length <= 1) {
    return EARTH_DEMO_ROUNDS[0];
  }

  const eligibleRounds = EARTH_DEMO_ROUNDS.filter(
    (round) => round.id !== normalizedLastRoundId,
  );
  const pool = eligibleRounds.length > 0 ? eligibleRounds : EARTH_DEMO_ROUNDS;
  const randomIndex = Math.floor(Math.random() * pool.length);
  return pool[randomIndex];
};
